export default __webpack_public_path__ + "static/media/vizualizacija-na-podatoci.1ea4561f.gif";